import { classNames } from '@dimjs/utils';
import { ReactElement } from 'react';
import { NativeProps } from '../utils';

export type VarGroupProps<V extends string> = NativeProps<V> & {
  children?: ReactElement | ReactElement[];
};

/**
 * 用于设置var
 * ```
 *  例如：
 *  <VarGroup<FormItemVarStyle> style={{ '--v-form-label-color': 'red' }}>
 *    <Form.Item />
 *    <Form.Item />
 *    <Form.Item />
 *  </VarGroup>
 *  可以为VarGroup中多个Form.Item设置统一的var style
 * ```
 */
export const VarGroup = <V extends string>(props: VarGroupProps<V>) => {
  return (
    <div className={classNames('v-var-group', props.className)} style={props.style}>
      {props.children}
    </div>
  );
};
